import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";

import { useAuthContext } from "../../contexts/AuthContext";
import { PageView } from "../../components/PageView";
import Loading from "../../components/Loading";

import "./index.css";


export default function SignUpRequestView() {
    const { getModelData } = useAuthContext();
    const { t } = useTranslation("appxweb");
    const { modelId } = useParams();
    const history = useHistory();
    const [ loading, setLoading ] = useState(true);
    const [ model, setModel ] = useState(null);

    if (!(modelId > 0)) {
        history.goBack();
    }

    useEffect(() => {
        async function fetchData() {
            let response = await getModelData({
                model: 'signuprequest',
                id: modelId,
            });

            if (!(response && response?.id > 0)) {
                history.goBack();
            }

            setModel(response);
            setLoading(false);
        }

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <PageView
            leadText={t('SignUpRequestView.leadText')}
            title={t('SignUpRequestView.title')}
            subTitle={t('SignUpRequestView.subTitle')}>
            {loading ? (<Loading />) : (
            <div className="sur-view">
                <p>{t('SignUpRequestView.message')}</p>
                <ul>
                    <li>
                        {t('SignUpRequestView.created_time')}:&nbsp;
                        <strong>{moment.unix(model.rec.createdTime).format('DD/MM/YYYY')}</strong>
                    </li>
                    <li>
                        {t('SignUpRequestView.your_code')}:&nbsp;
                        <strong>{model.rec.configId}</strong>
                    </li>
                </ul>
            </div>
            )}
        </PageView>
    );
};

